var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VRadioGroup',{staticClass:"my-0",attrs:{"value":_vm.values,"hide-details":"","disabled":_vm.readonly},on:{"change":_vm.onInput}},_vm._l((_vm.options),function({ text, value }){return _c('VRadio',{key:value,attrs:{"label":text,"value":value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }